export default __webpack_public_path__ + "static/media/graph.5dcc5f12.svg";